document.addEventListener("DOMContentLoaded", function() {
    const containers = document.querySelectorAll(".marquee-inner");
    
    containers.forEach((container, index) => {
        // Skip if container is empty or has no children
        if (!container || container.children.length === 0) {
            return;
        }
        
        // Clone the content for seamless scrolling
        const clones = container.cloneNode(true);
        container.appendChild(clones);

        // Create individual state for each marquee
        let scrollAmount = 0;
        let isPaused = false;
        
        // Detect mobile devices and set speed accordingly
        const isMobile = window.innerWidth <= 768;
        const speed = isMobile ? 1.0 : 0.5; // 2x speed on mobile

        function marqueeScroll() {
            if (!isPaused) {
                scrollAmount += speed;
                container.style.transform = `translateX(-${scrollAmount}px)`;
                if (scrollAmount >= container.scrollWidth / 2) {
                    scrollAmount = 0;
                }
            }
            requestAnimationFrame(marqueeScroll);
        }
        
        // Start the animation
        marqueeScroll();

        // Find the corresponding wrapper for this container
        const wrapper = container.closest(".marquee-wrapper");
        if (wrapper) {
            // wrapper.addEventListener("mouseenter", () => isPaused = true);
            wrapper.addEventListener("mouseleave", () => isPaused = false);
        }
    });
});